import React from 'react';
import PropTypes from 'prop-types';
import './main.less';

class Bottom extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (<div className="main-menu__bottom">
			{this.props.children}
		</div>);
	}
}
Bottom.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	])
};

export default Bottom;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/bottom/main.js